import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const SRewardDetailsInformation = styled.div`
  margin: 0 8px 24px 12px;

  ${setFlexDFFDC};
`;
